import React from 'react'
import TablaVistaProforma from '../components/proforma/TablaVistaProforma'

const ProformaView = () => {

    return (

        <div>

            <h3 className='mb-4'>Proformas</h3>

            <div className='mt-4'>
                <TablaVistaProforma/>
            </div>

        </div>

    )

}

export default ProformaView